export const constants = {
    allData: 'https://corona.lmao.ninja/v2/all',
    allCountries: 'https://corona.lmao.ninja/v2/countries?sort=cases',
}